/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Recursive method to check if value has any nested child
 */
export function anyNestedChild(value: unknown) {
  if (!value) return false;

  const hasChild = Object.values(value).some(child => {
    if (child === null) return false;
    if (child === undefined) return false
    if (typeof child === 'string' && child.trim() === '') return false
    if (typeof child === 'number' && isNaN(child)) return false
    if (child instanceof Date && isNaN(child as any)) return false
    if (!(child instanceof Date) && typeof child === 'object' && !anyNestedChild(child)) return false
    return true;
  });

  return hasChild;
}
